import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { CartStatus } from '../../types/drawer.types';
import { Cart } from '../../store/ducks/freight/types';

export default function usePatchCartStatus() {
  const [loading, setLoading] = useState(false);

  async function register({
    status,
    cartId,
    freightId,
  }: {
    status: CartStatus;
    cartId: string;
    freightId?: string;
  }): Promise<Cart | undefined> {
    try {
      setLoading(true);
      const response = await api.patch(`v1/backoffice/carts/${cartId}`, {
        cartStatus: status,
        freightId: freightId,
      });

      if (response.status === 200) {
        toast.success(ToastMessages.deliveries.success.patchCartStatus);
        return response.data;
      }
    } catch (error) {
      toast.error(ToastMessages.deliveries.error.patchCartStatus);
    } finally {
      setLoading(false);
    }
  }
  return { register, loading };
}
